/** @module SiteAdmin/CentricDrive/ChooseFileViewController */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/store/Nodes",
	"csi/view/ToolbarFind",
	"csi/table/Widget",

], function(declare,lang,Nodes,ToolbarFind,Widget) {

	return declare(Widget, {
		disableCustomViewToolbar: true,
		findAttributes: ["DisplayName"],
		plugins: ["find","refresh"],
		pluginsRight: [],

		class: "csi-view-driver-browser",

		/**
		 * @override
		 * Extension point to allow configuration of the main query level
		 * @param {QueryLevel} ql
		 */
		onCreateMainQueryLevel: function(ql) {
			ql.createCustomStore = lang.hitch(this, function(ctx) {
				return new Nodes({
					bSimpleQueryEngine: true,
					cachingStore: ctx.cache,
					requestModule: "SiteAdmin",
					requestOperation: "GetCentricDriveFiles",
					requestParameters: {
						"RelativePath": ctx.getNode().RelativePath
					}
				});
			});

			ql.hasChildrenTest = function(ctx) {
				return ctx.getNode().Type === "directory";
			};
		},

	});
});